<template>
  <div class="proce-payment-do">
    <GlobalInfoBar title="异常付款单据处理" content="店员微信支付付款，若用户阻断收款流程时，可手动重置单据" />
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <el-form :inline="true" :model="searchForm" size="small" @submit.native.prevent>
          <el-form-item label="订单编号">
            <el-input
              v-model="searchForm.orderNo"
              placeholder="请输入订单编号"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleSearch"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-row :gutter="20" class="content-row">
        <!-- 左侧：查询结果 -->
        <el-col :span="9">
          <div class="result-panel">
            <div class="panel-header">
              <span class="panel-title">查询结果</span>
               <span class="panel-note">
                说明：仅支持重置微信支付异常的单据。已收款成功的不可重置
               </span>
            </div>
            <div class="panel-body" v-loading="detailLoading">
              <template v-if="detailData">
                <div class="detail-item" :class="{ 'detail-item-center': item.key === 'wechatPayStatus' }" v-for="item in detailFields" :key="item.key">
                  <span class="detail-label">{{ item.label }}:</span>
                  <span
                    v-if="item.key === 'orderNo'"
                    class="detail-value detail-link"
                    @click="handleOrderClick"
                  >{{ detailData[item.key] || '--' }}</span>
                  <span
                    v-else-if="item.key === 'wechatPayStatus'"
                    class="detail-value detail-bold"
                  >
                    {{ transferStatus ? formatTransferStatus(transferStatus.transferStatus) : '--' }}
                    <span class="detail-buttons">
                      <el-button type="primary" size="small" round @click="handleSearch">查询</el-button>
                      <el-button
                        type="danger"
                        size="small"
                        round
                        :loading="resetLoading"
                        :disabled="!canReset"
                        @click="handleReset"
                      >
                        重置单据
                      </el-button>
                    </span>
                  </span>
                  <span v-else class="detail-value">
                    {{ detailData[item.key] || '--' }}
                    <span v-if="item.suffix">{{ item.suffix }}</span>
                  </span>
                </div>
              </template>
              <div v-else class="empty-tip">
                <span>请输入订单编号进行查询</span>
              </div>
            </div>
          </div>
        </el-col>
        <!-- 右侧：重置记录 -->
        <el-col :span="15">
          <div class="record-panel">
            <div class="panel-header">
              <span class="panel-title">重置记录</span>
            </div>
            <div class="record-table-wrap" v-loading="recordLoading">
              <el-table
                :data="recordList"
                border
                stripe
                size="small"
                style="width: 100%"
                :max-height="420"
              >
                <el-table-column type="index" label="序号" align="center" width="60" />
                <el-table-column prop="transferNo" label="出账单号" align="center" show-overflow-tooltip />
                <el-table-column label="放款状态" align="center">
                  <template slot-scope="{ row }">
                    <span :class="getLoanStatusClass(row.transferStatus)">{{ formatTransferStatus(row.transferStatus) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="withdrawUser" label="提现人" align="center" />
                <el-table-column prop="withdrawUserMobile" label="提现人手机号" align="center" />
                <el-table-column prop="resetUser" label="操作人" align="center" />
                <el-table-column prop="resetTime" label="操作时间" align="center" width="160" />
              </el-table>
            </div>
          </div>
        </el-col>
      </el-row>
    </GlobalChunk>
    <!-- 重置确认弹窗 -->
    <el-dialog
      title="操作提示"
      :visible.sync="resetDialogVisible"
      :close-on-click-modal="false"
      width="500px"
      custom-class="reset-dialog"
      center
    >
      <div class="reset-dialog-body">
        <p class="reset-warning">
          说明：重复单据可能会导致顾客重复收款，请确保顾客线下未收到款项
        </p>
        <p class="reset-question">是否确认重置该单号的付款状态？</p>
        <div class="reset-input-row">
          <span class="reset-input-label">动态口令:</span>
          <el-input
            v-model="dynamicPassword"
            placeholder="请输入动态口令"
            style="width: 300px"
            oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="resetLoading" @click="confirmReset">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";

export default {
  name: "proce-payment-do",
  data() {
    return {
      searchForm: {
        orderNo: ""
      },
      detailLoading: false,
      resetLoading: false,
      recordLoading: false,
      resetDialogVisible: false,
      dynamicPassword: "",
      detailData: null,
      transferStatus: null,
      recordList: [],
      detailFields: [
        { key: "orderNo", label: "订单号" },
        { key: "companyName", label: "所属商户" },
        { key: "storeName", label: "下单门店" },
        { key: "staffName", label: "下单店员" },
        { key: "amount", label: "用户收款金额", suffix: "元" },
        { key: "resetUser", label: "最近重置人" },
        { key: "resetTime", label: "最近重置时间" },
        { key: "transferNo", label: "提现单据" },
        {
          key: "wechatPayStatus",
          label: "微信付款状态"
        }
      ]
    };
  },
  computed: {
    canReset() {
      if (!this.detailData || !this.transferStatus) return false;
      return this.transferStatus.value !== 4;
    }
  },
  methods: {
    handleSearch() {
      if (!this.searchForm.orderNo) {
        this.$message.warning("请输入订单编号");
        return;
      }
      this.queryDetail();
      this.queryRecords();
    },
    queryDetail() {
      this.detailLoading = true;
      _api
        .queryAbnormalPayment({ orderNo: this.searchForm.orderNo })
        .then((res) => {
          if (res.code === 1) {
            this.detailData = res.data;
            this.transferStatus = null;
            if (this.detailData && this.detailData.transferNo) {
              this.queryTransferStatus(this.detailData.transferNo);
            }
          }
        })
        .finally(() => {
          this.detailLoading = false;
        });
    },
    queryTransferStatus(transferNo) {
      _api.getTransferStatus({ transferNo }).then((res) => {
        if (res.code === 1) {
          this.transferStatus = res.data;
        }
      });
    },
    queryRecords() {
      this.recordLoading = true;
      _api
        .getAbnormalPaymentRecords({ orderNo: this.searchForm.orderNo })
        .then((res) => {
          if (res.code === 1) {
            this.recordList = res.data || [];
          }
        })
        .finally(() => {
          this.recordLoading = false;
        });
    },
    handleReset() {
      this.dynamicPassword = "";
      this.resetDialogVisible = true;
    },
    confirmReset() {
      if (!this.dynamicPassword) {
        this.$message.warning("请输入动态口令");
        return;
      }
      if (!this.detailData || !this.detailData.transferNo) {
        this.$message.warning("未获取到放款单号");
        return;
      }
      this.resetLoading = true;
      _api
        .resetAbnormalPayment({
          transferNo: this.detailData.transferNo,
          command: this.dynamicPassword
        })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("单据重置成功");
            this.resetDialogVisible = false;
            this.queryDetail();
            this.queryRecords();
          }
        })
        .finally(() => {
          this.resetLoading = false;
        });
    },
    handleOrderClick() {
      if (this.detailData && this.detailData.orderNo) {
        const route = this.$router.resolve({
          path: "/RecallOrder/Details",
          query: { id: this.detailData.orderNo,type: "edit",}
        });
        window.open(route.href, "_blank");
      }
    },
    formatTransferStatus(status) {
      const map = {
        1: "待审核",
        2: "放款中",
        3: "已驳回",
        4: "放款成功",
        5: "放款失败",
        6: "已失效",
        7: "微信异常"
      };
      return map[status] || status;
    },
    getLoanStatusClass(status) {
      const text = typeof status === "number" ? this.formatTransferStatus(status) : status;
      if (text === "放款中") return "status-pending";
      if (text === "放款成功") return "status-success";
      if (text === "放款失败" || text === "已驳回" || text === "已失效" || text === "微信异常") return "status-fail";
      return "";
    }
  }
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.proce-payment-do {
  .content-row {
    margin-top: 20px;
  }

  .result-panel {
    background: #f5f2ff;
    border-radius: 8px;
    border: 1px solid #edeffd;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    overflow: hidden;
  }

  .record-panel {
    background: #fff;
    border-radius: 8px;
    border: 1px solid #edeffd;
    overflow: hidden;
  }

  .panel-header {
    height: 44px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    border-bottom: 1px solid #edeffd;
    background: #f9fbfd;

    .panel-title {
      font-size: 15px;
      font-weight: bold;
      color: #333;
      position: relative;
      padding-left: 10px;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 14px;
        background: #0981ff;
        border-radius: 2px;
      }
    }
  }

  .panel-note {
    // padding: 10px 16px;
    font-size: 12px;
    margin-left: 20px;
    color: #FFAF29;
    // line-height: 1.5;
    // background: #e4ecfd;
    // border-bottom: 1px solid #d6e0fa;
  }

  .panel-body {
    padding: 20px 16px;

    .detail-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;
      font-size: 14px;
      line-height: 1.5;

      &.detail-item-center {
        justify-content: center;
      }

      .detail-label {
        width: 110px;
        flex-shrink: 0;
        color: #999;
        text-align: left;
        padding-right: 4px;
      }

      .detail-value {
        flex: 1;
        color: #333;
        word-break: break-all;
      }

      .detail-link {
        color: #0981ff;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }

      .detail-bold {
        font-weight: bold;
        color: #333;

        .detail-buttons {
          display: inline-flex;
          align-items: center;
          margin-left: 16px;
          gap: 12px;
        }
      }
    }

    .empty-tip {
      text-align: center;
      padding: 40px 0;
      color: #ccc;
      font-size: 14px;
    }
  }

  .record-table-wrap {
    padding: 12px 16px 16px;
  }

  .status-pending {
    color: #e6a23c;
  }

  .status-success {
    color: #67c23a;
  }

  .status-fail {
    color: #f56c6c;
  }
}
</style>

<style lang="scss">
.reset-dialog {
  border-radius: 8px;
  overflow: hidden;

  .el-dialog__header {
    // background: #0981ff;
    // padding: 14px 20px;

    .el-dialog__title {
      color: #fff;
      font-size: 16px;
      font-weight: bold;
    }

    .el-dialog__headerbtn {
      top: 16px;

      .el-dialog__close {
        color: #fff;
        font-size: 18px;
      }
    }
  }

  .el-dialog__body {
    padding: 24px 24px 0;
  }

  .reset-dialog-body {
    .reset-warning {
      color: #f56c6c;
      font-size: 13px;
      line-height: 1.6;
      margin: 0 0 16px;
    }

    .reset-question {
      text-align: center;
      font-size: 15px;
      font-weight: bold;
      color: #333;
      margin: 0 0 20px;
    }

    .reset-input-row {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;

      .reset-input-label {
        font-size: 14px;
        color: #333;
        margin-right: 8px;
        white-space: nowrap;
      }
    }
  }

  .el-dialog__footer {
    padding: 16px 24px 20px;
    text-align: right;

    .el-button {
      min-width: 72px;
    }
  }
}
</style>
